export default function KampanieModal({
	isOpen,
	formName,
	setFormName,
	formDescription,
	setFormDescription,
	isSaving,
	onClose,
	onSubmit,
}) {
	if (!isOpen) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-md rounded-lg bg-white shadow-xl">
				<form onSubmit={onSubmit} className="p-5">
					<h3 className="text-base font-semibold text-gray-900">Edytuj kampanie</h3>
					<p className="mt-1 text-sm text-gray-500">Zaktualizuj nazwe i opis kampanii.</p>

					<div className="mt-4">
						<label htmlFor="kampanie-nazwa" className="block text-sm font-medium text-gray-700">
							Nazwa
						</label>
						<input
							id="kampanie-nazwa"
							type="text"
							value={formName}
							onChange={e => setFormName(e.target.value)}
							required
							autoFocus
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-4">
						<label htmlFor="kampanie-opis" className="block text-sm font-medium text-gray-700">
							Opis
						</label>
						<textarea
							id="kampanie-opis"
							rows={4}
							value={formDescription}
							onChange={e => setFormDescription(e.target.value)}
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-5 flex justify-end gap-2">
						<button
							type="button"
							onClick={onClose}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
							Anuluj
						</button>
						<button
							type="submit"
							disabled={isSaving || !formName.trim()}
							className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-400">
							{isSaving ? 'Zapisywanie...' : 'Zapisz zmiany'}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
